// hooks/useUserStatus.js
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setCurrentUserStatus, setOnlineUsers, updateUserStatus } from '../../features/Auth/authSlice';
import { profileApiSlice } from '../../features/Profile/profileApiSlice';

const useUserStatus = (socket, empCode, initialStatus) => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (empCode) {
      const initialUserStatus = initialStatus !== 'offline' && initialStatus !== undefined ? initialStatus : 'online';
      socket.emit('user-status-update', { empCode, status: initialUserStatus });
      dispatch(setCurrentUserStatus(initialUserStatus));

      socket.on('online-users', (onlineUsers) => {
        dispatch(setOnlineUsers(onlineUsers));
      });

      socket.on('user-status', (userStatus) => {
        dispatch(profileApiSlice.util.invalidateTags([{ type: 'Profile', id: userStatus?.empCode }]));
        dispatch(updateUserStatus(userStatus));
      });

      return () => {
        socket.emit('user-status-update', { empCode, status: 'offline' });
        socket.disconnect();
      };
    }
  }, [dispatch, socket, empCode]);

  const updateStatus = (status) => {
    socket.emit('user-status-update', { empCode, status });
    dispatch(setCurrentUserStatus(status));
  };

  return { updateStatus };
};

export default useUserStatus;
